import React from "react";
import { Form, Input, Row, Col, Card, DatePicker, Alert } from "antd";

const Pernyataan = ({ data, setData }) => {
    return (
        <Form layout="vertical">
            <Alert
                message="Dengan ini saya menyatakan bertanggung jawab atas kebenaran hal-hal yang diberitahukan dalam dokumen ini dan keabsahan dokumen pelengkap pabean yang menjadi dasar pembuatan dokumen ini"
                type="info"
                showIcon
                style={{ marginBottom: 20 }}
            />
            <Row gutter={24}>
                <Col span={12}>
                    <Card title="Tempat & Tanggal" bordered={true}>
                        <Form.Item label="Tempat">
                            <Input placeholder="Tempat" />
                        </Form.Item>
                        <Form.Item label="Tanggal">
                            <DatePicker style={{ width: "100%" }} />
                        </Form.Item>
                    </Card>
                </Col>
                <Col span={12}>
                    <Card title="Nama" bordered={true}>
                        <Form.Item label="Nama">
                            <Input placeholder="Nama" />
                        </Form.Item>
                        <Form.Item label="Jabatan">
                            <Input placeholder="Jabatan" />
                        </Form.Item>
                    </Card>
                </Col>
            </Row>
        </Form>
    );
};

export default Pernyataan;
